export interface IPixelAspect {
  x: number
  y: number
}
export interface ImageFile {
  file: File
  name: string
  dimensions: IPixelAspect
}
export enum ImageType {
  OrganisationHostedFavicon = 'organisation-hosted-favicon',
  OrganisationHostedLogo = 'organisation-hosted-logo',
  OrganisationHostedHero = 'organisation-hosted-hero',
  OrganisationLogo = 'organisation-logo',
  OrganisationContract = 'organisation-contract',
  GiftCategoryImage = 'gift-category-image',
  GiftItemImage = 'gift-item-image',
  GiftItemOverlay = 'gift-item-overlay-image',
  GiftItemHeader = 'gift-item-header',
  VoucherBanner = 'voucher-banner',
  SplashBackground = 'splash-background',
  SplashForeground = 'splash-foreground',
}
export interface IImageUploadResponse {
  id: number
  url: string
}
